import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetViewMessanger = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_MESSANGER_VIEW
            }); if (data.status === 'success') {
                dispatch(Action.SetGetViewMessangerAction({
                    id: data.data.id,
                    link: data.data.link,
                    type: data.data.type
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetViewMessanger as SetGetViewMessanger
}